// extracted by mini-css-extract-plugin
module.exports = {"obfuscator":"Obfuscator_obfuscator__1y-5Y","layer-of-blur":"Obfuscator_layer-of-blur__32Ys3","reason":"Obfuscator_reason__2tQQR","reason__text":"Obfuscator_reason__text__1BYMp"};